module.exports = __webpack_public_path__ + "img/jg9.c6b8adf4.png";